import React, { useEffect } from "react";

import "../../../assets/styles/pages/homeCss/CardSwiper.css";
import { BsArrowRightShort } from "react-icons/bs";


import "swiper/css";
import "swiper/css/pagination";

import card1 from "../../../assets/images/homeImages/CardSwiper/explore 1.svg";
import card2 from "../../../assets/images/homeImages/CardSwiper/lotus-flower 1.svg";
import card3 from "../../../assets/images/homeImages/CardSwiper/people-network 1.svg";
import card4 from "../../../assets/images/homeImages/CardSwiper/books 1.svg";
import card5 from "../../../assets/images/homeImages/CardSwiper/spa 2.svg";
import OwlCarousel from "react-owl-carousel";


export default function CardSwiper() {





  useEffect(() => {
    // AOS.init({ duration: 2000 });
  }, []);

  const options = {
    // margin: 30,
    responsiveClass: true,
    center: true,
    items: 5,
    // autoplay: true,
    loop: true,
    navText: ['<span className="owl-prev "><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M12.668 7.20162H1.0013M1.0013 7.20162L6.83464 1.36829M1.0013 7.20162L6.83464 13.035" stroke="#232728" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
      '<span className="owl-next"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M1.66406 7.20162H13.3307M13.3307 7.20162L7.4974 1.36829M13.3307 7.20162L7.4974 13.035" stroke="#232728" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>        </span>'],
    nav: true,
    // smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      500: {
        items: 2,
        nav: true,
      },
      600: {
        items: 2,
        nav: true,
      },
      700: {
        items: 2,
        nav: true,
      },
      900: {
        items: 2,
        nav: true,
      },
      1000: {
        items: 3,
        nav: true,
      },
      1200: {
        items: 3,
        nav: true,
      },
      1300: {
        items: 4,
        nav: true,
      },
      1400: {
        items: 4,
        nav: true,
      },
      1500: {
        items: 5,
        nav: true,
      },
      1700: {
        items: 5,
        nav: true,
      },
    },
  };


  return (
    <>
      <div className="cardSwiper-main" id="demo">
        <OwlCarousel className="owl-theme owl-carousel " {...options}>
          <div className="item">
            <div className="owl_card1">
              <div className="card-circle">
                <img src={card1} alt=" card imgs1" />
              </div>

              <div className="card-containt home-card-text">
                <p>Automation of well-being scheduling throughout a year</p>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="owl_card2">
              <div className="card-circle">
                <img src={card2} alt=" card imgs2" />
              </div>

              <div className="card-containt home-card-text">
                <p className="text-white">Saving >80% time managing employe well-being</p>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="owl_card3">
              <div className="card-circle">
                <img src={card3} alt=" card imgs3" />
              </div>

              <div className="card-containt home-card-text">
                <p className="text-white">
                  24/7/365 functionality
                </p>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="owl_card4">
              <div className="card-circle">
                <img src={card4} alt=" card imgs4" />
              </div>

              <div className="card-containt home-card-text">
                <p className="text-white">Marketing and reporting automation</p>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="owl_card5">
              <div className="card-circle">
                <img src={card5} alt=" card imgs5" />
              </div>

              <div className="card-containt home-card-text  ">
                <p>Interactive events calendar</p>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="owl_card6">
              <div className="card-circle">
                <img src={card2} alt=" card imgs2" />
              </div>
              <div className="card-containt home-card-text">
                <p className="text-white">Show employees that they are valued</p>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="owl_card7">
              <div className="card-circle">
                <img src={card3} alt=" card imgs3" />
              </div>
              <div className="card-containt home-card-text">
                <p className="text-white">
                  Simple integration and technical setup
                </p>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="owl_card8">
              <div className="card-circle">
                <img src={card4} alt=" card imgs2" />
              </div>

              <div className="card-containt home-card-text">
                <p className="text-white">Change and customise as you go </p>
              </div>
            </div>
          </div>
        </OwlCarousel>
      </div>
    </>
  );
}
